module.exports = __webpack_public_path__ + "img/12.04390edf.jpg";